import React, { useState } from 'react';

// MUI
import { Grid, MenuItem, Select, FormControlLabel, Switch } from '@mui/material';

import { timezones } from '../../../../../utils/timezones';

function DateTimeRegion({ col, classes, handleChangeDtFormat }) {
  const [outputFormat, setOutputFormat] = useState(col.dtFormat.outputFormat);
  const [timezone, setTimezone] = useState(col.dtFormat.timezone);
  const [dateOnly, setDateOnly] = useState(col.dtFormat.dateOnly || false);

  const handleOnBlurOutputFormat = () => {
    if (outputFormat === col.dtFormat.outputFormat) return;
    handleChangeDtFormat(col.id, outputFormat, 'outputFormat');
  };

  const handleOnBlurTimezone = () => {
    if (timezone === col.dtFormat.timezone) return;
    handleChangeDtFormat(col.id, timezone, 'timezone');
  };

  const handleToggleDateOnly = (checked) => {
    setDateOnly(checked);
    handleChangeDtFormat(col.id, checked, 'dateOnly');
    // If switching to date-only, reset format if it includes time
    if (checked && outputFormat.includes('kk:mm')) {
      const newFormat = outputFormat.replace(' kk:mm', '');
      setOutputFormat(newFormat);
      handleChangeDtFormat(col.id, newFormat, 'outputFormat');
    }
    if (checked && outputFormat === 'Iso-8601') {
      setOutputFormat('dd/MM/YYYY');
      handleChangeDtFormat(col.id, 'dd/MM/YYYY', 'outputFormat');
    }
  };

  return (
    col && (
      <Grid item>
        <Grid item xs={12} style={{ marginTop: '8px' }}>
          <FormControlLabel
            control={
              <Switch
                checked={dateOnly}
                onChange={e => handleToggleDateOnly(e.target.checked)}
                size="small"
              />
            }
            label="Date only (no time picker)"
          />
        </Grid>
        <Grid item xs={12} style={{ marginTop: '8px' }}>
          <span style={{ fontSize: '12px', color: '#666' }}>Output format</span>
          <Select
            onChange={e => {
              setOutputFormat(e.target.value);
            }}
            onBlur={handleOnBlurOutputFormat}
            className={classes.selectList}
            variant={'outlined'}
            value={outputFormat}
            defaultValue={'dd/MM/YYYY kk:mm'}
            size="small"
            fullWidth
          >
            <MenuItem value={'dd LLLL YYYY'}>dd Month yyyy [01 February 2021]</MenuItem>
            {!dateOnly && (
              <MenuItem value={'dd LLLL YYYY kk:mm'}>dd Month yyyy hh:mm [01 February 2021 14:01]</MenuItem>
            )}
            <MenuItem value={'dd/MM/YY'}>dd/mm/yy [01/02/21]</MenuItem>
            {!dateOnly && <MenuItem value={'dd/MM/YY kk:mm'}>dd/mm/yy hh:mm [01/02/21 14:01]</MenuItem>}
            <MenuItem value={'dd/MM/YYYY'}>dd/mm/yyyy [01/02/2021]</MenuItem>
            {!dateOnly && <MenuItem value={'dd/MM/YYYY kk:mm'}>dd/mm/yyyy hh:mm [01/02/2021 14:01]</MenuItem>}
            <MenuItem value={'dd-MM-YYYY'}>dd-mm-yyyy [01-02-2021]</MenuItem>
            {!dateOnly && <MenuItem value={'dd-MM-YYYY kk:mm'}>dd-mm-yyyy hh:mm [01-02-2021 14:01]</MenuItem>}
            <MenuItem value={'MM/dd/YYYY'}>mm/dd/yyyy [02/01/2021]</MenuItem>
            {!dateOnly && <MenuItem value={'MM/dd/YYYY kk:mm'}>mm/dd/yyyy hh:mm [02/01/2021 14:01]</MenuItem>}
            <MenuItem value={'YYYY-MM-dd'}>yyyy-mm-dd [2021-02-01]</MenuItem>
            {!dateOnly && <MenuItem value={'YYYY-MM-dd kk:mm'}>yyyy-mm-dd hh:mm [2021-02-01 14:01]</MenuItem>}
            {!dateOnly && <MenuItem value={'Iso-8601'}>ISO 8601 [2021-02-01T14:01:00±Timezone]</MenuItem>}
            <MenuItem value={'Unix'}>Unix [1612148400]</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} style={{ marginTop: '8px' }}>
          <span style={{ fontSize: '12px', color: '#666' }}>Timezone</span>
          <Select
            onChange={e => setTimezone(e.target.value)}
            onBlur={handleOnBlurTimezone}
            className={classes.selectList}
            variant={'outlined'}
            value={timezone}
            defaultValue={'GMT+10'}
            size="small"
            fullWidth
          >
            <MenuItem value="" disabled>
              {' '}
              Select timezone
            </MenuItem>
            {timezones.length > 0 &&
              timezones.map((item, index) => (
                <MenuItem value={item.offset} key={index}>
                  {' '}
                  {item.name} {item.offset}{' '}
                </MenuItem>
              ))}
          </Select>
        </Grid>
      </Grid>
    )
  );
}

export default DateTimeRegion;
